function animateProgress(container, duration) {
  const progressBar = container.querySelector('.js-kolona-progress-bar').children[0];
  progressBar.style.transform = 'translateX(100%)';
  progressBar.style.transitionDuration = String(duration);
  progressBar.style.transitionTimingFunction = 'linear';
}

function calculateAndSetBlockSize(container, timeout) {
  let height = 0;
  const child = Array.from(container.children)[0];
  if (child) {
    height += child.offsetHeight + parseInt(getComputedStyle(child).marginBottom);
  }
  container.dataset.height = String(height);
  container.dataset.maxHeight = String(container.scrollHeight);
  container.style.transitionDuration = '300ms';
  container.style.transitionProperty = 'max-height';
  if (container.classList.contains('open')) {
    container.style.maxHeight = `${container.scrollHeight}px`;
    animateProgress(container, timeout);
  } else {
    container.style.maxHeight = `${height}px`;
  }
}

function closeSlide(slide) {
  slide.classList.remove('open');
  slide.style.maxHeight = `${slide.dataset.height}px`;
  const progressBar = slide.querySelector('.js-kolona-progress-bar').children[0];
  progressBar.removeAttribute('style');
}

function activateSlide(
  expandableBlocks,
  parent,
  timeoutDuration,
  pictures,
  index,
  isProgressStarted = true,
) {
  expandableBlocks.forEach((block) => {
    const currentSlide = block.querySelector('.js-expandable-container');
    const progressBar = currentSlide.querySelector('.js-kolona-progress-bar').children[0];
    progressBar.removeAttribute('style');
    if (currentSlide.classList.contains('open')) {
      closeSlide(currentSlide);
    }
  });
  parent.classList.add('open');
  parent.style.maxHeight = `${parent.dataset.maxHeight}px`;

  if (isProgressStarted) {
    animateProgress(parent, `${timeoutDuration}ms`);
  }

  pictures.forEach((picture) => {
    if (picture.classList.contains('active')) {
      picture.classList.remove('active');
      const progressBar = picture.querySelector('.js-kolona-progress-bar').children[0];
      progressBar.removeAttribute('style');
    }
  });
  pictures[index].classList.add('active');
  if (isProgressStarted) {
    animateProgress(pictures[index], `${timeoutDuration}ms`);
  }
}

function kolonaSliderInit() {
  const kolonaSlider = document.getElementById('kolona-slider');
  if (!kolonaSlider) return;
  const timeoutDuration = kolonaSlider.dataset.timeout;
  let counter = 0;
  if (kolonaSlider) {
    const expandableBlocks = kolonaSlider.querySelectorAll('.js-expandable-parent');
    const triggerButtons = kolonaSlider.querySelectorAll('.js-expandable-button');
    const pictures = kolonaSlider.querySelectorAll('.js-slider-picture');

    if (expandableBlocks) {
      expandableBlocks.forEach((block) => {
        const container = block.querySelector('.js-expandable-container');
        if (!container) return;
        calculateAndSetBlockSize(container, `${timeoutDuration}ms`);
        pictures.forEach((p) => {
          if (p.classList.contains('active')) {
            animateProgress(p, `${timeoutDuration}ms`);
          }
        });
        window.addEventListener('resize', () => {
          calculateAndSetBlockSize(container, `${timeoutDuration}ms`);
        });
      });
    }
    if (triggerButtons) {
      let timeoutId = null;
      triggerButtons.forEach((button, i) => {
        button.addEventListener('click', () => {
          clearInterval(timeoutId);
          pictures.forEach((picture) => {
            if (picture.classList.contains('active')) {
              const progressBar = picture.querySelector('.js-kolona-progress-bar').children[0];
              progressBar.removeAttribute('style');
            }
          });
          counter = i;
          const parent = button.parentElement;
          if (parent.classList.contains('open')) {
            closeSlide(parent);
          } else {
            activateSlide(expandableBlocks, parent, timeoutDuration, pictures, i, false);
          }
        });
      });

      timeoutId = setInterval(() => {
        counter++;
        const current = triggerButtons[counter % triggerButtons.length];
        const parent = current.parentElement;
        const t = Number(counter % triggerButtons.length);
        activateSlide(expandableBlocks, parent, timeoutDuration, pictures, t);
      }, Number(timeoutDuration));
    }
  }
}

export default kolonaSliderInit;
